import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { setTheme, setUser } from '../redux/actions';
import { IStaticMethods } from "preline/preline";
import { getAuthUrl, getBaseUrl } from '../config/auth';

const APP_ENV = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;
//console.log('Current APP_ENV on load:', APP_ENV);

declare global {
    interface Window {
        HSStaticMethods: IStaticMethods;
    }
}

function PrivateRoute({ setTheme, setUser, redirectPath = '/login', children }) {
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.body.classList.remove('overflow-hidden');
    }, []);

    useEffect(() => {
        if (!loading && isAuthenticated) {
            window.HSStaticMethods.autoInit();
        }
    }, [location.pathname, isAuthenticated, loading]);

    useEffect(() => {
        const checkAuthentication = async () => {
            const token = localStorage.getItem('token');
            if (token) {

                // Possiamo decodificare il token per ottenere tutte le info
                // console.log("Token: " , token)
                setIsAuthenticated(true);
                
                // Recupera le informazioni dell'utente dal localStorage
                const userStr = localStorage.getItem('user');
                if (userStr) {
                    const user = JSON.parse(userStr);
                    setUser({ user });
                }

                // Imposta il tema
                const theme = localStorage.getItem('theme') || 'light';
                setTheme({ theme });
            } else {
                setIsAuthenticated(false);
            }
            setLoading(false);
        };

        checkAuthentication();
    }, [setTheme, setUser]);

    const redirectToLogin = () => {
        const baseUrl = getBaseUrl();
        window.location.href = getAuthUrl();
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
    //    console.log('User not authenticated, redirecting...');
        redirectToLogin();
        return null;
    }

    return children;
}

export default connect(
    null,
    { setTheme, setUser }
)(PrivateRoute);